<template>
  <footer class="footer">
    <div class="holder">
      <div class="copyright">Copyright &copy; SAEDA. All rights reserved.</div>
      <div class="logo">
        <a href="#">
          <img src="../../assets/logo-footer.png" alt="logo" />
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style scoped>
</style>